import styled from 'styled-components';

import MuiCollapse from '@material-ui/core/Collapse';

export const Collapse = styled(MuiCollapse)`
  margin-left: ${({ theme }) => theme.spacing(1)}px;
  border-left: 1px solid;
  border-color: ${({ theme }) => theme.palette.grey[300]};
`;
